import { __assign, __read, __spread } from "tslib";
import { addGlobalEventProcessor, SDK_VERSION } from '@sentry/browser';
/**
 * A global side effect that makes sure Sentry events that user
 * `@sentry/react` will correctly have Sentry events associated
 * with it.
 */
function createReactEventProcessor() {
    if (addGlobalEventProcessor) {
        addGlobalEventProcessor(function (event) {
            event.sdk = __assign(__assign({}, event.sdk), { name: 'sentry.javascript.react', packages: __spread(((event.sdk && event.sdk.packages) || []), [
                    {
                        name: 'npm:@sentry/react',
                        version: SDK_VERSION,
                    },
                ]), version: SDK_VERSION });
            return event;
        });
    }
}
export * from '@sentry/browser';
export { Profiler, withProfiler, useProfiler } from './profiler';
export { ErrorBoundary, withErrorBoundary } from './errorboundary';
export { createReduxEnhancer } from './redux';
export { reactRouterV3Instrumentation } from './reactrouterv3';
export { reactRouterV4Instrumentation, reactRouterV5Instrumentation, withSentryRouting } from './reactrouter';
createReactEventProcessor();
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@sentry/react/esm/index.js
// module id = 56
// module chunks = 0